import React from "react";
import { Routes, Route } from "react-router-dom";
import ConnectingVessels from "./ConnectingVessels";
import ConnectingVesselCreateEdit from "./ConnectingVesselCreateEdit";

const index = () => {
	return (
		<Routes>
			<Route index element={<ConnectingVessels />} />
			<Route path='/create' element={<ConnectingVesselCreateEdit />} />
			<Route path='/:id/edit' element={<ConnectingVesselCreateEdit />} />
		</Routes>
	);
};

export default index;
